import React from "react";
import styled, { css } from "styled-components";

import StaticBoard from "../../components/StaticBoard";
import {NumberToColorDict} from "../../components/ColorToNumberDict"

export const Container = styled.div`
margin: 0.5em;
width: 90vw;
text-align: left;
display: flex;
flex-direction: column;


${props => props.primary && css `  
   flex-direction: row; 
   text-align: left;
  `}

`;


const InstructionImage = styled.img`
overflow: scroll;
width: 80vw;
margin: 1em;

`;

const demo = "0006600000000066000000066003006600000000002663662000000000020203020200000000022230322200000000003306033000000000332226222330000000002026202000000000000206020000000000000006000000000"

export const Part1Exposition = 
<div>
	<Container primary>
		<Container>
		<p>
			In our tasks you will draw images on a drawing board such 
			as the "butterfly" on the right. 
			<br/> Our tasks use the <b> Hexagon Board </b> - a drawing boardgame that is paved with hexagonal tiles.
			<br/><br/>Please use a desktop device (a computer or a laptop) and a mouse preferably with Google Chrome to complete the tasks.
		</p>
		</Container>
		<Container style = {{background: "white"}}> 
			<StaticBoard 
			 boardState = {demo}
			 NumberedBoard = {1}			
			/> 
		</Container>
	</Container>
	
	<Container primary>
	<Container style={{width:"50vw"}}>
	<p>
		Each task displays a drawing procedure step by step.  
		In each step, paint the Hexagon Board according to this step.
		<br/> <br/>
		The only colors used in our tasks are: &nbsp; 
		<mark style ={{backgroundColor:NumberToColorDict[2]}}>Yellow</mark>,&nbsp; 
		<mark style ={{backgroundColor:NumberToColorDict[7]}}>Orange</mark>,&nbsp;
		<mark style ={{backgroundColor:NumberToColorDict[4]}}>Red</mark>,&nbsp;
		<mark style ={{backgroundColor:NumberToColorDict[6]}}>Purple</mark>,&nbsp;
		<mark style ={{backgroundColor:NumberToColorDict[5]}}>Blue</mark>,&nbsp;
		<mark style ={{backgroundColor:NumberToColorDict[3]}}>Green</mark>,&nbsp; 
		<mark style ={{backgroundColor:NumberToColorDict[1], color:"white"}}>Black</mark>, and &nbsp; 
		<mark style ={{backgroundColor:NumberToColorDict[0]}}>White</mark>
	</p>
	</Container>
	
	<InstructionImage 
			style={{background: "white"}}
			src={require ('../../data/demo/IntroDemo07a.png')} 		
		/>  
	</Container>
</div>

export const Part1Content = 
<Container>	
	<p> In our tasks we will show you drawing procedures. 
		Your task is to paint the Hexagon Board according to those drawing procedures.
		<br/> In the term "drawing procedure" we mean a list of instructions or actions 
		one should take on the Hexagon Board in order to get a certain image. 
		<br/> The drawing procdure is comprised from drawing steps and is displayed step by step. 
		It is very important that in each step you will paint exactly as the displayed drawing step says. 		
	</p>
	
	<Container primary>
		<Container style={{width:"50vw"}}>	
		<p>
		<br/> The drawing steps will be displayed on the left side of the screen one step at a time.
		<br/><br/> The right side of the screen contains:
		<ul>
			<li> An empty <b> Hexagon Board </b> comprising of <b> hexagonal tiles </b> you can paint on</li>
			<br/><li> A <b> color palette </b> from which you select the color you want to paint tiles with </li>
			<br/><li> A <b> color indicator </b> that indicates the color which is currently selected </li>
		</ul>
		</p>
		</Container>
		<InstructionImage src={require ('../../data/demo/IntroDemo05.png')} /> 
	</Container>
	
	<Container primary>
		<Container style={{width:"50vw"}}>
			<p>
			These are the only colors used in our tasks: 
			</p>
		</Container>
		
		<InstructionImage src={require ('../../data/demo/IntroDemo11.png')} />  
	</Container>
	
	
	In each step you will paint according to the drawing step that is currently being 
	displayed. 
	<br/> In the rest of the page we will demonstrate it on an example.
	
	{/* example: part 1*/}
	<Container primary>
		<Container style={{width:"50vw"}}>	
		<p>	
		<b> Start </b> <br/>
		At the beginning of the task, click the highlighted START button to see the 
		first drawing step.
		</p>
		</Container>
		<InstructionImage src={require ('../../data/demo/IntroDemo06.png')} /> 
	</Container>
	
	{/* example: part 2*/}
	<Container primary>
		<Container style={{width:"50vw"}}>	
		<p>	<br/>
		<br/>
		<b> Step 1 </b> <br/>
		In this example the first drawing step is "Paint tile 1 blue". 
		<br/> This step is displayed on the left side of the screen and marked in yellow. 
		<br/><br/> The picture on the right illustrates how you may carry out this drawing step. 
		<br/><br/><b>Note:</b> Double click on the same tile deletes its color. 
		</p>
		</Container>
		<InstructionImage src={require ('../../data/demo/IntroDemo07b.png')} /> 
	</Container>
	
	{/* example: part 3*/}	
	<Container primary>
		<Container style={{width:"40vw"}}>	
			<p>
			<br/>
			<b> Step 2 </b> <br/>
			After clicking NEXT you will see the second drawing step. 
			<br/> In our example the second drawing step is "Paint all the tiles below it blue". 
			<br/><br/> The second drawing step is marked in yellow to indicate that 
			it is the drawing step you are currently carrying out. 
			<br/><br/> Carry out this drawing step the same way we explained above.
			<br/> Once you finish, click NEXT.
			</p>
		</Container>
		<InstructionImage src={require ('../../data/demo/IntroDemo08.png')} /> 
	</Container>
	
	<Container primary>
		<Container style={{width:"30vw"}}>	
		<p>
		<b>Note:</b> Once you click NEXT you cannot edit the painting for 
		the previous drawing step. 
		Make sure you are carrying out the current drawing step <i> completely and accurately </i>before 
		you are clicking NEXT and move on to the next drawing step.	
		</p>
		</Container>
	</Container>
	
	{/* example: part 4*/}
	<Container primary>
		<Container style={{width:"40vw"}}>	
			<p>
			<br/><br/>
			<b> Next Steps </b> <br/>
			Continue to carry out drawing steps one by one. 
			<br/><br/>
			<b> Note: </b> 
			The current drawing step which you should carry out is always marked in yellow. 
			Previous drawing steps are displayed above it.  
			
			</p>
		</Container>
		<InstructionImage src={require ('../../data/demo/IntroDemo09.png')} /> 
	</Container>
	
	{/* example: part 4*/}
	<Container primary>
		<Container style={{width:"40vw"}}>	
			<p>
			<b> Final Step </b> <br/>
			Once you finished carrying out all the drawing steps the DONE button becomes 
			highlighted and you should click DONE.
			</p>
		</Container>
		<InstructionImage src={require ('../../data/demo/IntroDemo10.png')} /> 
	</Container>
	
</Container>




